import type { ReactNode } from "react";

export function Empty({ children }: { readonly children: ReactNode }) {
	return <div className="px-4 py-10 text-center text-caption text-ink-3">{children}</div>;
}
